import { render, staticRenderFns } from "./DetailsNotify.vue?vue&type=template&id=3a8de1d2&"
import script from "./DetailsNotify.vue?vue&type=script&lang=js&"
export * from "./DetailsNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports